import ApiFetch from "@paylands-frontend/api/dist/ApiFetch";
import { ClearLocalStorage } from "./ClearLocalStorage";
import { SERVER_URL } from "Env";

export const Api = new ApiFetch(
    SERVER_URL,
    new ClearLocalStorage().clear,
);
